import { createFileRoute } from '@tanstack/react-router';
import { ClientesPage, lerBuscaClientes } from '@/components/clientes';

export const Route = createFileRoute('/_app/clientes')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaClientes(bruto),
  component: ClientesRota,
});

function ClientesRota() {
  return <ClientesPage busca={Route.useSearch()} />;
}
